import { render } from "./ChassisCheck.vue?vue&type=template&id=44a59232&scoped=true&ts=true"
import script from "./ChassisCheck.vue?vue&type=script&lang=ts"
export * from "./ChassisCheck.vue?vue&type=script&lang=ts"

import "./ChassisCheck.vue?vue&type=style&index=0&id=44a59232&lang=less&scoped=true"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44a59232"]])

export default __exports__